module.exports = __webpack_public_path__ + "static/media/AvatarFemale.85d98a1a.svg";